import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ROUTES } from 'routes';
import { PayboxService } from 'api/Paybox/PayboxService';
import { IPayboxForm, PayboxTypeCarte } from 'types';
import { PayboxForm } from 'components';

export const PaymentRedirectionPage: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const { transactionId, username, price, typeCarte, vehicleCategory, redirectionOnError, action } = location.state as {
    transactionId: string;
    username: string;
    price: number;
    typeCarte: PayboxTypeCarte;
    vehicleCategory: string;
    redirectionOnError?: string;
    action: 'create' | 'renew' | 'upsell' | 'update';
  };
  const [form, setForm] = useState<IPayboxForm | undefined>(undefined);

  if (!(transactionId || username || price)) {
    history.replace(redirectionOnError || ROUTES.publicationOptions);
  }

  useEffect(() => {
    PayboxService.getFormData(transactionId, username, price, typeCarte, vehicleCategory, action).then(setForm);
  }, [transactionId, username, price, typeCarte, vehicleCategory, action]);

  return form ? <PayboxForm url={form.url} elements={form.elements!} /> : null;
};
